// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const inputClasses = {
  clearTrigger: "qui-input__clear-trigger",
  errorIndicator: "qui-input__error-indicator",
  errorText: "qui-input__error-text",
  group: "qui-input__input-group",
  hint: "qui-input__hint",
  icon: "qui-input__icon",
  input: "qui-input__input",
  label: "qui-input__label",
  requiredIndicator: "qui-input__required-indicator",
  root: "qui-input__root",
} as const
